import { mountSocialsRightsForm } from './socials-rights-controller'
// Separate static-HTML entry: no dependency on the React app or its session.
mountSocialsRightsForm(document)
